import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthService } from '../../../shared/services/auth.service';
import { AppInfo, RESPONSE, EitUrl, EitEnv } from '../../../shared/services/env.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
// import { SocialAuthService } from "angularx-social-login";
// import { SocialUser } from "angularx-social-login";
// import { FacebookLoginProvider } from "angularx-social-login";
import { AppService } from '../../../shared/services/app.service';
import { ApiService } from '../../../shared/services/api.service';
// import { HttpClient } from '@angular/common/http';
// import { map } from 'rxjs/operators';

const fbLoginOptions = {
  scope: 'public_profile,email'
};

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  regForm: FormGroup;
  returnUrl: string = "/"
  // userSocial: SocialUser;
  themeLogo: string = ''; // Default Logo
  appInfo: any = AppInfo
  appData: any = null;
  selectedTab: string = "login"

  constructor(private toastService: ToastrService, private route: ActivatedRoute, private router: Router, private authService: AuthService, 
              private appService: AppService, private api: ApiService/* , private authSocialService: SocialAuthService, private http: HttpClient */) { 
    this.route.queryParams.subscribe(params => {
      if (params && params['returnUrl']) {
        console.log("Return URL: " + params['returnUrl'])
        this.returnUrl = params['returnUrl'];
      }
    });
     
    this.appService.appObs.subscribe(x => { 
      this.appData = x;
    })
    this.loginForm = new FormGroup({
      email: new FormControl("", [Validators.required, Validators.email]),
      password: new FormControl("", [Validators.required, Validators.minLength(6)]),
    })
    this.regForm = new FormGroup({
      name: new FormControl("", [Validators.required]),
      lastname: new FormControl("", [Validators.required]),
      phone: new FormControl("", [Validators.required]),
      email: new FormControl("", [Validators.required, Validators.email]),
      password: new FormControl("", [Validators.required, Validators.minLength(6)]),
      cpassword: new FormControl("", [Validators.required, Validators.minLength(6)]),
      terms: new FormControl(true, [Validators.required, Validators.requiredTrue]),
      privacy: new FormControl(true, [Validators.required, Validators.requiredTrue]),
      newsletter: new FormControl(false),
      profiling: new FormControl(false),
    })
  }

  ngOnInit(): void {
    console.log("login")
   /*  this.authSocialService.authState.subscribe((user) => {
      if (user != null)
      {
        console.log(JSON.stringify(user))

        var userFb = {id : "", email : "", name : ""};
        userFb.id = user.id;
        if(user.email)
        {
          userFb.email = user.email;
        }
        if(user.name)
        {
          userFb.name = user.name;
        }
        
        this.authService.loginFB(userFb).pipe(first()).subscribe(data => {
          if (data[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK && data[RESPONSE.JP_RESULT]) {
            this.router.navigate([this.returnUrl]);
          }
          else this.toastService.error("Username e/o password errate!")
        });
      }
    }); */
  }

  loginGul(){

    let url = EitUrl.apiLoginGulliver + EitEnv.baseUrl + this.returnUrl;
    window.open(url,"_self"/*, "_blank"*/);
    
    /*
    if(this.loginForm.valid){

      //mando alla loro pagina di login:

      //postj_T(endpoint: string, body: any, reqOpts?: any): Observable<any> {
        
    
        var headers = { 'Content-Type': 'application/json', 'Authorization': '', "X-Auth-Key": AppInfo.GULLIVER_APIKEY };
        var b = '';
        let token = "";
        let reqOpts = {};
    
        / *
        if (token) {
          var bearer: string = 'Bearer ' + this.token;
          headers.Authorization = bearer;
          b = 'access-token=' + this.token;
          url = url + '?' + b;
        }
        * /
        let body = {};
        reqOpts = {'headers' : headers};
    
        / *
        return this.http.post<any>(url, body, reqOpts)
          .pipe(
            map(data => data)
          )
          * /
      //}
      
    }
    else{
      let rErr = "Mancano i seguenti campi: "
      let err1 = false;
      if(!this.loginForm.controls['email'].valid && this.loginForm.controls['email'].getError('required')) {
        rErr += "<br> Email"
        err1 = true;
      }
      else if(!this.loginForm.controls['email'].valid && this.loginForm.controls['email'].getError('email')) this.toastService.error("Email non valida!")

      if(!this.loginForm.controls['password'].valid && this.loginForm.controls['password'].getError('required')) {
        rErr += "<br> Password"
        err1 = true;
      }
      else if(!this.loginForm.controls['password'].valid && this.loginForm.controls['password'].getError('minlength')) this.toastService.error("Password non valida!")

      if (err1)  this.toastService.error(rErr)
    }
    */

  }
  login(){
    if(this.loginForm.valid){

      this.authService.login(this.loginForm.value).pipe(first()).subscribe(data => {
        if (data[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK && data[RESPONSE.JP_RESULT]) {
          this.router.navigate([this.returnUrl]);
        }
        else this.toastService.error("Username e/o password errate!")
      });
    }
    else{
      let rErr = "Mancano i seguenti campi: "
      let err1 = false;
      if(!this.loginForm.controls['email'].valid && this.loginForm.controls['email'].getError('required')) {
        rErr += "<br> Email"
        err1 = true;
      }
      else if(!this.loginForm.controls['email'].valid && this.loginForm.controls['email'].getError('email')) this.toastService.error("Email non valida!")

      if(!this.loginForm.controls['password'].valid && this.loginForm.controls['password'].getError('required')) {
        rErr += "<br> Password"
        err1 = true;
      }
      else if(!this.loginForm.controls['password'].valid && this.loginForm.controls['password'].getError('minlength')) this.toastService.error("Password non valida!")

      if (err1)  this.toastService.error(rErr)
    }
  }

  recovery(){
    this.router.navigate(['pages/forget/password'])
  }

  fbLogin(){
    // this.authSocialService.signIn(FacebookLoginProvider.PROVIDER_ID, fbLoginOptions);  
  }

  register(){
    this.regForm.patchValue({cpassword: this.regForm.controls['password'].value})
    if(this.validate()){
      this.api.register(this.regForm.value, "").subscribe(res => {
        if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK && res[RESPONSE.JP_RESULT]) {          
          this.router.navigate(['pages/registration-complete'])
        }
        else{
          this.toastService.error(this.msgError(res[RESPONSE.JP_MSG]), "Attenzione! Controlla i dati inseriti!")          
        }
      }, err =>{
        this.toastService.error(this.msgError(err), "Attenzione! Controlla i dati inseriti!") 
      })
    }
  }

  msgError (err: any){
   return "<ul>" + (err.email != null ? "<li>" + err.email[0] + "</li>" : "") + (err.name != null ? "<li>" + err.name[0] + "</li>" : "") +
                   (err.lastname != null ? "<li>" + err.lastname[0] + "</li>" : "") + (err.phone != null ? "<li>" + err.phone[0] + "</li>" : "") +  
                   (err.password != null ? "<li>" + err.password[0] + "</li>" : "") + "</ul>";                 
  }

  validate(){
    if(!this.regForm.valid){
      let rErr = "Mancano i seguenti campi: "
      let err1 = (!this.regForm.controls['name'].valid && this.regForm.controls['name'].getError('required')) || 
                 (!this.regForm.controls['lastname'].valid && this.regForm.controls['lastname'].getError('required')) ||
                 (!this.regForm.controls['phone'].valid && this.regForm.controls['phone'].getError('required')) ||
                 (!this.regForm.controls['email'].valid && this.regForm.controls['email'].getError('required')) ||
                 (!this.regForm.controls['password'].valid && this.regForm.controls['password'].getError('required')) ||
                /* (!this.regForm.controls['birthdate'].valid && this.regForm.controls['birthdate'].getError('required')) ||
                 (!this.regForm.controls['zip'].valid && this.regForm.controls['zip'].getError('required')) ||
                 (!this.regForm.controls['townstr'].valid && this.regForm.controls['townstr'].getError('required')) ||*/
                 (!this.regForm.controls['terms'].valid) || (!this.regForm.controls['privacy'].valid);

      if(!this.regForm.controls['name'].valid && this.regForm.controls['name'].getError('required')) rErr += "<br> Nome";

      if(!this.regForm.controls['lastname'].valid && this.regForm.controls['lastname'].getError('required')) rErr += "<br> Cognome";

      if(!this.regForm.controls['phone'].valid && this.regForm.controls['phone'].getError('required')) rErr += "<br> Telefono";

     // if(!this.regForm.controls['birthdate'].valid && this.regForm.controls['birthdate'].getError('required')) rErr += "<br> Data di Nascita";

      //if(!this.regForm.controls['zip'].valid && this.regForm.controls['zip'].getError('required')) rErr += "<br> CAP";

      //if(!this.regForm.controls['townstr'].valid && this.regForm.controls['townstr'].getError('required')) rErr += "<br> Città";

      if(!this.regForm.controls['email'].valid && this.regForm.controls['email'].getError('required')) rErr += "<br> Email"
      else if(!this.regForm.controls['email'].valid && this.regForm.controls['email'].getError('email')) this.toastService.error("Email non valida!")

      if(!this.regForm.controls['password'].valid && this.regForm.controls['password'].getError('required')) rErr += "<br> Password"
      else if(!this.regForm.controls['password'].valid && this.regForm.controls['password'].getError('minlength')) this.toastService.error("Password non valida!")

      if(!this.regForm.controls['terms'].valid && this.regForm.controls['terms'].getError('required')) rErr += "<br> Devi leggere ed accettare le Condizioni generali di uso";
      else if(!this.regForm.controls['terms'].valid && this.regForm.controls['terms'].getError('requiredtrue')) rErr += "<br> Devi leggere ed accettare le Condizioni generali di uso";

      if(!this.regForm.controls['privacy'].valid && this.regForm.controls['privacy'].getError('required')) rErr += "<br> Devi leggere ed accettare l'Informativa privacy";
      else if(!this.regForm.controls['privacy'].valid && this.regForm.controls['privacy'].getError('requiredtrue')) rErr += "<br> Devi leggere ed accettare l'Informativa privacy";

      if (err1) this.toastService.error(rErr)
      return false;
    }
    return true; 
  }

}
